module.exports = __webpack_public_path__ + "static/media/logo-white.794ed1c5.svg";